import * as actionTypes from '../actions/types';
import Hierarchy from '../models/Hierarchy';
import { Paginate } from '../services/PaginateResponse';


export interface HierarchyReducerState {
    readonly rootUser:      Hierarchy | null;
    readonly children:      Paginate<Hierarchy[]> | null;
    readonly message:       string | null;
    readonly isLoading:     boolean;
    readonly isLoadingMore: boolean;
}

const INITIAL_STATE: HierarchyReducerState = {
    rootUser:      null,
    children:      null,
    message:       null,
    isLoading:     false,
    isLoadingMore: false,
}

export default (state: any = INITIAL_STATE, action: any) => {
    switch (action.type) {

        case actionTypes.HIERARCHY_FETCH:
            return {
                ...state,
                rootUser:  action.payload.data?.user     ?? null,
                children:  action.payload.data?.children ?? null,
                message:   action.payload.message,
                isLoading: false,
            };

        case actionTypes.HIERARCHY_FETCH_NEXT: {
            const existing = state.children?.data ?? [];
            const incoming: Paginate<Hierarchy[]> | undefined = action.payload.data?.children;

            if (!incoming || incoming.current_page <= (state.children?.current_page ?? 0)) {
                return { ...state, isLoadingMore: false };
            }

            return {
                ...state,
                children:      { ...incoming, data: existing.concat(incoming.data ?? []) },
                isLoadingMore: false,
            };
        }

        case actionTypes.HIERARCHY_CHANGE_VALUE:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };

        case actionTypes.AUTH_LOGOUT:
            return { ...INITIAL_STATE };

        default:
            return state;

    }
}
